module.exports = __webpack_public_path__ + "img/golf.d9ca71a8.svg";